import type { TrackingData } from '@ecomm/tracking-types/Data'
import type { ODMONPlacement } from '@ecomm/tracking-types/Odmon'
import { useCallback } from 'react'
import { useTracking } from 'react-tracking'

export function useTrackOdmonTermsServiceClick() {
  const { trackEvent } = useTracking<TrackingData>()

  return useCallback(
    (placement: ODMONPlacement) => {
      trackEvent({
        placement: placement,
        event: 'terms-of-service-click'
      })
    },
    [trackEvent]
  )
}
